module.exports = [
  {
    name: "Krunker",
    id: 0,
    opacity: 0.6,
  },
  {
    name: "Target",
    id: 1,
    opacity: 0.6,
  },
  {
    name: "GG",
    id: 2,
    opacity: 0.6,
  },
  {
    name: "Pumpkin",
    id: 3,
    opacity: 0.6,
  },
  {
    name: "Spooky",
    id: 4,
    opacity: 0.6,
  },
  {
    name: "Ded",
    id: 5,
    opacity: 0.6,
  },
  {
    name: "Sadface",
    id: 6,
    opacity: 0.6,
  },
  {
    name: "Laugh Cry",
    id: 7,
    opacity: 0.7,
  },
  {
    name: "Sid",
    id: 8,
    opacity: 0.9,
  },
  {
    name: "Vince",
    id: 9,
    opacity: 0.9,
  },
  {
    name: "Kiki",
    id: 10,
    opacity: 0.6,
  },
  {
    name: "Ladder",
    id: 11,
    opacity: 1,
  },
  {
    name: "Dummy",
    id: 12,
    opacity: 1,
  },
  {
    name: "8 Ball",
    id: 13,
    opacity: 0.6,
  },
  {
    name: "xD",
    id: 14,
    opacity: 0.6,
  },
  {
    name: "MMOK",
    id: 15,
    opacity: 0.7,
  },
  {
    name: "Madman",
    id: 16,
    opacity: 0.6,
  },
  {
    name: "Terminal",
    id: 17,
    opacity: 0.6,
  },
  {
    name: "YODO",
    id: 18,
    opacity: 0.6,
  },
  {
    name: "Crayon",
    id: 19,
    opacity: 0.6,
  },
  {
    name: "Myth",
    id: 20,
    opacity: 0.85,
  },
  {
    name: "SpikyJohn",
    id: 21,
    opacity: 0.85,
  },
  {
    name: "LevelGaming",
    id: 22,
    opacity: 0.9,
  },
  {
    name: "PolarAce",
    id: 23,
    opacity: 0.9,
  },
  {
    name: "FrostyWolf",
    id: 24,
    opacity: 0.85,
  },
  {
    name: "Waspy",
    id: 25,
    opacity: 0.85,
  },
  {
    name: "Kpal",
    id: 26,
    opacity: 0.9,
  },
  {
    name: "Rain Song",
    id: 27,
    opacity: 0.85,
  },
  {
    name: "nV",
    id: 28,
    opacity: 0.9,
  },
  {
    name: "BV Hype",
    id: 29,
    opacity: 0.85,
  },
  {
    name: "Kaarson",
    id: 30,
    opacity: 0.9,
  },
  {
    name: "Deal With It",
    id: 31,
    opacity: 0.9,
  },
  {
    name: "Rice",
    id: 32,
    opacity: 0.9,
  },
  {
    name: "Lore",
    id: 33,
    opacity: 0.95,
  },
  {
    name: "Desu Sid",
    id: 34,
    opacity: 0.85,
  },
  {
    name: "Anomaly",
    id: 35,
    opacity: 0.85,
  },
  {
    name: "FaZe",
    id: 36,
    opacity: 0.9,
  },
  {
    name: "Nudah",
    id: 37,
    opacity: 0.9,
  },
  {
    name: "Misfits",
    id: 38,
    opacity: 0.9,
  },
  {
    name: "Bill $aber",
    id: 54,
    opacity: 0.9,
  },
  {
    name: "Fields Food v1",
    id: 55,
    opacity: 0.9,
  },
  {
    name: "Fields Food v2",
    id: 56,
    opacity: 0.9,
  },
  {
    name: "Phil",
    id: 57,
    opacity: 0.9,
  },
  {
    name: "VoKUS",
    id: 58,
    opacity: 0.8,
  },
  {
    name: "StremZ",
    id: 59,
    opacity: 0.9,
  },
  {
    name: "Zed",
    id: 63,
    opacity: 0.9,
  },
  {
    name: "Northern Forces",
    id: 64,
    opacity: 0.9,
  },
  {
    name: "Sorable",
    id: 65,
    opacity: 0.9,
  },
  {
    name: "Syctis",
    id: 66,
    opacity: 0.9,
  },
  {
    name: "Moon Juice",
    id: 79,
    opacity: 0.9,
  },
  {
    name: "caL",
    id: 83,
    opacity: 0.9,
  },
  {
    name: "Quacky",
    id: 87,
    opacity: 0.9,
  },
  {
    name: "Verb",
    id: 88,
    opacity: 0.9,
    frames: 4,
    frameT: 250,
  },
];
